<template>
    <div>
        <div class="w-100"> <img src="@/assets/imagenes/micrositioPlaneacion/planeacion-microsite-header.jpg" class="w-100" alt=""> </div>

        <!-- login -->
        <div v-if="flagLogin">
            <login-component
                @userNoAutenticado="userNoAutenticado=$event"
                @register="register=$event"
            >
            </login-component>
        </div>
        <!-- Registro busqueda del empleado-->
        <div v-if="flagRegister_v1" v-scroll-reveal>
            <div class="container form-registro p-0"> <!--formulario-registro--->
                <form v-on:submit.prevent="getDatosEmpleado()">
                    <div class="d-flex justify-content-between" style="background: #fafafa; border-bottom: 2px solid #efefef;">
                        <h5 class="ml-4 mb-0 py-2 text-muted">Registro de usuario</h5>
                        <button @click="irLogin" class="px-4 btn btn-link text-primary" style="text-decoration-line: underline;"><i class="d-none fas fa-long-arrow-alt-left"></i><span class="" style="font-size:.8rem; font-weight:500">Iniciar sesion</span></button>
                    </div>
                    <div class="p-5">
                        <p class="text-muted mb-4" style="color: #7f7d88; font-size:21px">Datos Personales</p>
                        <div class="row">
                            <div class="col-md-6">
                                <div>
                                    <label for="num_empleado">N° de Empleado</label>
                                    <input type="text" v-model.number="numEmpleado" class="form-control form-control-lg" id="num_empleado" :disabled="validated == 1">
                                    <p v-if="error_busqueda == 1 || error_busqueda == 3" class="small text-danger my-0"> *Debe de agregar un N° de empleado</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div>
                                    <label for="rfc">RFC</label>
                                    <input type="text" v-model="rfc" class="form-control form-control-lg" id="rfc" :disabled="validated == 1" oninput="this.value = this.value.toUpperCase()">
                                    <p v-if="error_busqueda == 2 || error_busqueda == 3" class="small text-danger my-0"> *Debe de agregar un RFC</p>
                                </div>
                            </div>
                        </div>
                        <div class="botonera d-flex justify-content-end mt-5 mb-0">
                            <button v-show="!ver_datosEmpleado" @click="setearCampos" type="button" class="btn btn-vino-o mr-2
                            ">Limpiar Campos</button>
                            <button v-show="!ver_datosEmpleado" type="submit" class="btn btn-vino
                            ">Buscar</button>
                        </div>
                    </div>

                </form>
                <div v-if="ver_datosEmpleado" class="area_datos_empleado">
                    <div class="mb-5" v-show="loading">
                        <spiner></spiner>
                        <h6 class="text-center text-muted text-cargando"> Cargando datos del empleado...</h6>
                    </div>
                    <div v-show="!loading">

                        <div v-if="datos_empleado.length > 0">
                            <!-- <code>{{this.datos_empleado}}</code>    -->
                            <div v-for="(datos_emp, a) in datos_empleado" :key="a">
                                <div class="row mt-3 mx-0 px-5">
                                    <label for="num_empleado_busq">Nombre empleado</label>
                                    <input type="text" :value="datos_emp.nombre + ' ' + datos_emp.apePat + ' ' + datos_emp.apeMat" class="form-control form-control-lg" id="num_empleado_busq" disabled>
                                </div>
                                <div class="row mt-3 mx-0 px-5">
                                    <label for="rfc_busq">Categoria</label>
                                    <input type="text" v-model="datos_emp.nombreCategoria" class="form-control form-control-lg" id="rfc_busq" disabled>
                                </div>
                                <div class="botonera d-flex justify-content-end p-5 mb-0">
                                    <button @click="setearCampos" type="button" class="leyenda btn btn-vino-o mr-2
                                    ">No son mis datos</button>
                                    <button @click="setDatosCuenta_vista" type="submit" class="leyenda btn btn-vino">Correcto</button>
                                </div>
                            </div>
                        </div>
                        <div v-else class="w-100 text-center py-5">
                            <div>
                                <p class="sinResult text-muted">Sin resultados</p>
                                <i class="far fa-frown fa-2x" style="color:#bebebe;"></i>
                            </div>
                            <button @click="setearCampos" type="button" class="leyenda btn btn-vino-o mt-3 ">Realizar otra búsqueda</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Registro datos de la cuenta -->
        <div v-if="flagRegister_v2">
              <!-- <form-datos-cuenta :datos_empleado="datos_empleado"></form-datos-cuenta> -->
            <div class="container my-5 p-0">
                <form v-on:submit.prevent="realizarRegistro()">
                    <div class="form-registro shadow-sm mb-4">
                        <div class="d-flex justify-content-between" style="background: #fafafa; border-bottom: 2px solid #efefef;">
                            <h5 class="ml-4 mb-0 py-2 text-muted">Registro de usuario</h5>
                            <button @click="irLogin" class="px-4 btn btn-link text-primary" style="text-decoration-line: underline;"><i class="d-none fas fa-long-arrow-alt-left"></i><span class="" style="font-size:.8rem; font-weight:500">Iniciar sesion</span> </button>
                        </div>
                        <div class="datos">
                            <p class="text-muted mb-3" style="color: #7f7d88; font-size:21px">Datos del empleado</p>
                            <div class="datosEmpleado">
                                <p class="text-muted mb-0">Nombre del empleado: <span style="color: #70777d">{{datos_empleado[0].nombre + " " + datos_empleado[0].apePat + " " + datos_empleado[0].apeMat}}</span> </p>
                                <p class="text-muted mb-0">N° de Empleado: <span style="color: #70777d">{{datos_empleado[0].cveEmpl}}</span> </p>
                            </div>
                            <div class="datosEmpleado">
                                <p class="text-muted mb-0">Categoría: <span style="color: #70777d">{{datos_empleado[0].nombreCategoria}}</span> </p>
                                <p class="text-muted mb-0">RFC: <span style="color: #70777d">{{datos_empleado[0].rfc}}</span> </p>
                            </div>
                        </div>
                    </div>
                    <div class="paddingDatosCta form-registro mt-1">
                        <p class="text-muted mb-0" style="color: #7f7d88; font-size:21px">Datos de la cuenta</p>
                        <small class="mt-0"><i class="fas fa-exclamation-circle text-info"></i> Guardar en un lugar seguro el nombre de usuario y contraseña registrados en este formulario, ya que serán requeridos cada vez que inicie sesión.</small>
                        <div v-if="errores_registro == 8" class="alert alert-danger" role="alert">
                            Error al registrar usuario, empleado ya registrado.
                            <ul class="m-0 " v-for="(errorInfo, e) in array_error_registro " :key="e">
                                <li class="m-0 p-0">{{errorInfo}}</li>
                            </ul>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label for="login">Establezca un nombre de usuario <b class="ml-2">Nota: Por favor evitar los espacios en blanco</b> </label>
                                <input type="text" v-model.trim="logeo" class="form-control form-control-lg" id="login">
                                <p v-if="errores_registro == 1 || errores_registro == 6" class="small text-danger my-0"> *Debe de agregar un nombre de usuario</p>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label for="email">Email</label>
                                <input type="email" v-model.trim="email" class="form-control form-control-lg" id="email">
                                <p v-if="errores_registro == 2 || errores_registro == 6" class="small text-danger my-0"> *Debe de agregar un email</p>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label for="contrasenia">Contraseña</label>
                                <input type="password" v-model.trim="contrasenia" class="form-control form-control-lg" id="contrasenia">
                                <p v-if="errores_registro == 3 || errores_registro == 6" class="small text-danger my-0"> *Debe de agregar una contraseña</p>
                                <p v-if="contrasenia" :class="color_pass">{{contrasenia.length > 0 || errores_registro == 9? tamanio_pass : ""}}</p>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label for="contrasenia_confirm">Confirmar contraseña</label>
                                <input type="password" v-model.trim="contrasenia_repit" class="form-control form-control-lg" id="contrasenia_confirm">
                                <p v-if="errores_registro == 4 || errores_registro == 6" class="small text-danger my-0"> *Debe de escribir de nuevo la contraseña</p>
                                <p v-if="errores_registro == 5" class="small text-danger my-0"> *Las contraseñas no coinciden. Intentelo de nuevo</p>
                            </div>
                        </div>
                        <div class="capchaStyle pl-0 mt-3">
                            <re-capcha @verCaptcha="verCaptcha = $event" @inputCaptcha="inputCaptcha = $event"></re-capcha>
                            <p v-if="errores_registro == 7 || errores_registro == 6" class="small text-danger my-0"> *Los códigos no coinciden. Intentelo de nuevo</p>
                        </div>
                        <div class="d-flex justify-content-end mt-5 mb-0">
                            <button @click="verInicioRegistro" type="button" class="btn btn-vino-o mr-2 px-5">Cancelar</button>
                            <button type="submit" class="btn btn-vino px-5">Registrar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- Registro pantalla de activación -->
        <div v-if="flagRegister_v3">
            <div v-show="loading_registro" style="margin: 5.5rem 0">
                <spiner></spiner>
                <div v-if="maxHeight && flagLogin == false" style="padding-bottom:7%;"></div>
                <!-- <h6 class="text-center text-muted text-cargando">..</h6> -->
            </div>
            <div v-show="!loading_registro">
                <div class="container form-registro p-0">
                        <div class="d-flex justify-content-between" style="background: #fafafa; border-bottom: 2px solid #efefef;">
                            <h5 class="ml-4 mb-0 py-2 text-muted">Confirmación de la cuenta</h5>
                        </div>
                        <div class="padding-activacion pt-2 pb-4">
                            <form v-on:submit.prevent="activarCuenta">
                                <div v-if="error_activacion == 2" class="alert alert-danger" role="alert">
                                    Error al activar la cuenta. Codigo de activación incorrecto.
                                </div>
                                <div v-if="error_activacion ==3" class="alert alert-danger" role="alert">
                                    ¡El código ingresado ha expirado! Intente obtener un nuevo código
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <p v-if="tipo_mensaje_activacion == 1" class="text-confirmacion text-center">
                                            Gracias por registrarte a este servicio <span style="font-weight:600">{{datos_empleado[0].nombre + " " + datos_empleado[0].apePat + " "  + datos_empleado[0].apeMat}}</span>, le hemos
                                            enviado un código de activación al correo <span style="font-weight:600">{{email}}</span>. Si no recibió el correo, puede obtener un nuevo código de activación. Por favor concluye el registro introduciendo dicho código a continuación:
                                        </p>
                                        <!-- <p v-if="tipo_mensaje_activacion == 2" class="text-confirmacion text-center">
                                            Estimado usuario, el código de activación fue enviado a su correo electrónico, verifique su bandeja de entrada. Si no recibió el correo puede
                                            <span @click="solicitarNuevoCodigo()" class="link-nuevo-codigo">obtener un nuevo código de activación</span> , por favor concluye el registro introduciendo dicho código a continuación:
                                        </p>   -->
                                        <div v-if="tipo_mensaje_activacion == 2" class="px-3 d-flex justify-content-center">
                                            <p class="mt-3 mb-3 text-mail">
                                                Estimado usuario, el código de activación fue enviado a su correo electrónico, verifique su bandeja de entrada.
                                                <br>
                                                Si no recibió el correo, o el código ya ha caducado, puede obtener un nuevo código de activación
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column align-items-center mt-4 codigoActivacion">
                                    <label for="codigo" class="cod-activacion">Código de activación</label>
                                    <div class="input-group inputActivacion">
                                        <input type="text" v-model.trim="codigo_activacion" class="form-control form-control-lg text-center" id="codigo" placeholder="Ingrese el código de activación">
                                         <div class="input-group-append">
                                            <button type="submit" class="btn btn-vino">Activar cuenta</button>
                                         </div>
                                    </div>
                                    <p v-if="error_activacion == 1" class="small text-danger my-0"> *Ingrese el código de activación</p>
                                </div>
                                <div class="div-activar-cuenta mb-0">
                                    <a @click="solicitarNuevoCodigo()" class="link-nuevo-codigo">Obtener nuevo código de activación</a>
                                    <!-- <button type="submit" class="btn btn-vino activar-cuenta-boton px-5">Activar cuenta</button> -->
                                </div>
                            </form>
                        </div>
                </div>
            </div>
        </div>
        <!-- Registro pantalla de cuenta activada flagRegister_v4-->
        <div v-if="flagRegister_v4" v-scroll-reveal>
            <div class="container p-0 mb-5 finalizarRegistro" style="border-radius:5px; border: 2px solid #c4c3c3;">
                <div class="pt-5 text-white text-center" style="color: #02a443; /*background:#02a443 !important;*/ border-top-left-radius:5px; border-top-right-radius:5px;">
                    <i class="text-success far fa-check-circle fa-4x mb-4"></i>
                    <p class="h3 ml-2 p-0 text-success mb-4 text-center" style="color: #7f7d88; font-size:21px">Cuenta activada correctamente</p>
                </div>
                <div class="text-center px-5 pb-5 mb-0">
                    <p class="m-0 paddingFinalizar h6 pt-2 px-3" style="color:#a29b9b;">Estimado usuario, su cuenta fue creada y activada satisfactoriamente, por favor inicie sesión</p>
                    <button type="button" @click="irLogin" class="btn btn-primary px-5 py-2">Iniciar sesión</button>
                </div>
            </div>
        </div>
        <div v-if="maxHeight && flagLogin == false" style="padding-bottom:9%;"></div>

    </div>
</template>
<script>

import axios from "axios";
import spiner from "./../spiner.vue"
import ReCapcha from './../capcha.vue'
import loginComponent from "./components/login.vue"
import AutorizacionTramiteshacienda from "./../../services/autorizacionTramites.js"
import ServicesTramiteshacienda from '../../services/serviciosTramites'
const _serviciosHacienda = new ServicesTramiteshacienda();
const _servicesAuth = new AutorizacionTramiteshacienda();


export default({
    name: 'login-registro',
    components:{
        spiner,
        ReCapcha,
        // formDatosCuenta,
        loginComponent,

    },
    data: function(){
        return{
            flagLogin: true,

            /*datos q se llenan desde $emit */
                userNoAutenticado: { idusuario: null, email: null, noAutenticado: null},
                register: false,
            /***/

            //registro
            flagRegister_v1: false,
            flagRegister_v2: false,
            flagRegister_v3: false,
            flagRegister_v4: false,
            errores_registro: 0,
            array_error_registro: [],
            //endpoint_datos_empleado: 'http://172.30.9.90/APIEMPLEADOSRH/Persona/BuscaRFCURP/',
            endpoint_datos_empleado: 'http://187.157.114.104/APIEMPLEADOSRH/Persona/BuscaRFCURP/',
            numEmpleado: null,
            rfc: '',
            datos_empleado: [],
            ver_datosEmpleado: false,
            validated: 0,
            loading: true,
            error_busqueda:0,

            ///registro
            logeo: '',
            email: '',
            contrasenia: '',
            contrasenia_repit:'',
            tamanio_pass: null,
            color_pass: null,
            // captcha
            verCaptcha: '',
            inputCaptcha: '',

            objectToRegistrar_sinactivacion: {},
            token: '',
            datos_registro: [],
            loading_registro: false,

            //activación
            codigo_activacion: "",
            objectActivarCuenta: {},
            error_activacion:0,
            tipo_mensaje_activacion: 0,

            //solicitar nuevo código
            objectSolicitarCodigo:{},
            respuestaSolicitarCodigo:{},
        }
    },
    computed:{
        maxHeight(){ return window.screen.height>800? true : false },
    },
    methods: {
        getDatosEmpleado: async function(){
            if (this.numEmpleado == null) {
                this.error_busqueda = 1;
            }if (this.rfc == "") {
                this.error_busqueda =2
            } if (this.numEmpleado == null && this.rfc == "") {
               this.error_busqueda = 3
            }
            else if(this.numEmpleado != null && this.rfc != ""){
                this.ver_datosEmpleado = true;
                this.error_busqueda = 0;
                let result = null;

                result = await _servicesAuth.GetDatosEmpleado(this.rfc, this.numEmpleado);
                    if(result.success)
                    {
                        this.datos_empleado = result.data;
                        this.loading = false;
                        this.validated = 1;
                    }
                    else{ console.log(result.error); }
            }
        },
        setearCampos: function(){
            this.numEmpleado = null;
            this.rfc = "";
            this.ver_datosEmpleado = false;
            this.validated = 0;
            window.scrollTo(0, 0);
            this.datos_empleado = [];
            this.loading = true;
            this.error_busqueda = 0;
            this.errores_registro = 0;
        },
        getTokenServe: async function(){
           let result = null;
            result = await _servicesAuth.GetTokenServer2();
            if(result.success)
            {
                this.token = result.data;
            }
            else{ console.log(result.error); }
        },
        setDatosCuenta_vista: function(){
            this.flagRegister_v1 = false;
            this.flagRegister_v2 = true;
            window.scrollTo(0, 0);
            this.getTokenServe();
        },
        consultaRegistro_sinActivacion: async function(object_body){
            window.scrollTo(0, 0);
            let config_Serve = {
                method: 'POST',
                url: 'https://evolucion.finanzaschiapas.gob.mx:8083/Key/api/Auth/Registrar_sinactivacion',
                headers: {
                    'accept': '/',
                    'Authorization' : 'Bearer' + ' ' + this.token,
                    'Content-Type': 'application/json'
                },
                data : object_body
            };
            // console.log('config_Serve', config_Serve);

            await axios(config_Serve)
            .then(response => {
                // console.log(JSON.stringify(response.data));
                this.datos_registro = response.data;
                //console.log(this.datos_registro);
                this.flagRegister_v1 = false;
                this.flagRegister_v2 = false;
                this.flagRegister_v3 = true;
                this.loading_registro = false;
                this.tipo_mensaje_activacion = 1; //mensaje de activación en el correo
            })
            .catch(error => {
                if (error.response.status == 400){
                    this.flagRegister_v3 = false;
                    this.flagRegister_v2 = true;
                    this.loading_registro = false;
                    this.errores_registro = 8;
                    this.array_error_registro =  error.response.data.errores;
                    console.log("el error aqui!!!", error.response.data.errores);
                }
            });
        },
        realizarRegistro: function(){
                this.objectToRegistrar_sinactivacion = {
                login: this.logeo,
                correo_electronico: this.email,
                nombre_pantalla: this.datos_empleado[0].nombre + " " + this.datos_empleado[0].apePat + " " + this.datos_empleado[0].apeMat,
                curp: this.datos_empleado[0].curp,
                puesto: this.datos_empleado[0].nombreCategoria,
                contraseña: this.contrasenia,
                apikey: "B6B08AF9-7917-4882-80F0-16222E792944",
                idrol: 1043
            }
            if (this.logeo == '' && this.email == '' && this.contrasenia == '' && this.contrasenia_repit == '' && this.inputCaptcha == "") {
                this.errores_registro = 6;
            }
            else if ((this.logeo == '' || this.email == '' || this.contrasenia == '' || this.contrasenia_repit == '') || (this.contrasenia != this.contrasenia_repit) || (this.inputCaptcha != this.verCaptcha) || (this.contrasenia.length < 8)) {
                if(this.logeo == '') return this.errores_registro = 1; if(this.email == '') return this.errores_registro = 2; if(this.contrasenia == '') return this.errores_registro = 3; if(this.contrasenia_repit == '') return this.errores_registro = 4;
                if (this.contrasenia != this.contrasenia_repit) return this.errores_registro = 5;
                if (this.inputCaptcha != this.verCaptcha) return this.errores_registro = 7;
                if (this.contrasenia.length < 8) return this.errores_registro = 9;


            }
            else{
                this.errores_registro = 0;
                this.flagRegister_v2 = false;
                this.flagRegister_v3 = true;
                this.loading_registro = true;
                this.consultaRegistro_sinActivacion(this.objectToRegistrar_sinactivacion);
          }
        },
        //Activación de la cuenta
        activarCuenta: function(){
            if (this.codigo_activacion == "") {
                this.error_activacion = 1;
            } else{
                this.objectActivarCuenta = this.tipo_mensaje_activacion == 1? {
                    idusuario: this.datos_registro.idusuario,
                    email: this.datos_registro.correo_electronico,
                    codigo_activacion: this.codigo_activacion
                } : {
                    idusuario: this.userNoAutenticado.idusuario,
                    email: this.userNoAutenticado.email,
                    codigo_activacion: this.codigo_activacion
                }
        //    console.log("aqui el objeto: ", this.objectActivarCuenta);
            let config_Serve = {
                method: 'put',
                url: 'https://evolucion.'+this.urlSubdominio+':8083/key/api/Auth/Activar',
                headers: {
                    'Authorization' : 'Bearer' + ' ' + this.token,
                    'Content-Type': 'application/json'
                },
                data : this.objectActivarCuenta
            };
             axios(config_Serve)
            .then(response => {
                this.flagRegister_v1 = false;
                this.flagRegister_v2 = false;
                this.flagRegister_v3 = false;
                this.flagRegister_v4 = true;

            })
            .catch(error => {
                if (error.response.status == 400){
                     this.error_activacion = 2;
                }
                if (error.response.status == 401){
                     this.error_activacion = 3;
                }
            });
        }
        },
        solicitarNuevoCodigo: function(){
            this.loading_registro = true;
            this.objectSolicitarCodigo = this.tipo_mensaje_activacion == 1? {
                idusuario: this.datos_registro.idusuario,
                email: this.datos_registro.correo_electronico,
                codigo_activacion: ""
            } : {
                    idusuario: this.userNoAutenticado.idusuario,
                    email: this.userNoAutenticado.email,
                    codigo_activacion: ""  // aqui
                };
            let config_Serve = {
                method: 'put',
                url: 'https://evolucion.'+this.urlSubdominio+':8083/key/api/Auth/Code',
                headers: {
                    'Authorization' : 'Bearer' + ' ' + this.token,
                    'Content-Type': 'application/json'
                },
                data : this.objectSolicitarCodigo
            };
             axios(config_Serve)
            .then(response => {
                this.respuestaSolicitarCodigo = response.data;
                //this.tipo_mensaje_activacion = 2; //mensaje de activación cuando se solicita código de nuevo
                this.error_activacion = 0;
                this.loading_registro = false;

            })
            .catch(error => {
                console.log(error);
            });
        },
        verInicioRegistro: function(){ ///vuelve a la pantalla principal
            this.setearCampos();
            this.flagRegister_v1 = true;
            this.flagRegister_v2 = false;
            this.ver_datosEmpleado = false;
            this.logeo = null;
            this.email = null;
            this.contrasenia = null;
            this.contrasenia_repit = null;
            this.inputCaptcha = "";
        },
        irLogin: function(){
            this.setearCampos();
            this.flagLogin = true;
            this.register = false;
            this.flagRegister_v1 = false;
            this.flagRegister_v2 = false;
            this.flagRegister_v3 = false;
            this.flagRegister_v4 = false;

            this.logeo = null;
            this.email = null;
            this.contrasenia = "";
            this.contrasenia_repit = null;
            this.inputCaptcha = "";
        },
        getTipoPass: function(tamanio){
            if (tamanio < 8) {
                this.tamanio_pass = "Muy débil- Por favor, introduce una contraseña más fuerte"
                this.color_pass = 'text-danger'
            }
            if(tamanio == 8 || tamanio == 9){
                this.tamanio_pass = "Debil -Por favor, Te sugerimos introducir una contraseña más fuerte"
                this.color_pass = 'text-warning'
            }
            if(tamanio > 9){
                this.tamanio_pass = "Segura - Contraseña fuerte"
                this.color_pass = 'text-success'
            }
        },
        // si hay un usuario logueado, se redirige a la vista de tramites
        validarRuta: async function(){
             let idUsuario = await _serviciosHacienda.getIdUsuario();
             if(idUsuario) this.$router.push({name: 'TramitesHacienda'});
        }
    },
    created(){
        this.validarRuta();
    },
    watch:{
       userNoAutenticado: function(){
           if(this.userNoAutenticado.noAutenticado){
                this.getTokenServe();
                this.flagLogin = false;
                this.flagRegister_v3 = true;
                this.tipo_mensaje_activacion = 2; //mensaje de activación en el login
           }
       },
       register: function(){
           if(this.register){
                this.flagLogin = false;
                this.flagRegister_v1 = true;
           }
       },
       contrasenia: function(){
           this.tamanio_pass = this.contrasenia.length;
           this.getTipoPass(this.tamanio_pass);
       }

    },
    mounted(){
        window.scrollTo(0, 0);
    }
})
</script>
<style scoped>
    #formulario-login .container{
        max-width: 1000px !important;
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }
    #formulario-login .img{width:25%;}
    label, .text-confirmacion{
        color: #777272 !important;
        margin-bottom: 0 !important;
    }
    #formulario-login .tramite{
        width: 30%;
        background-color: #f7f7f7;
        display: flex !important;
        align-items: center !important;
        /* background-image: url(img.jpg); */
    }
    #formulario-login .login{
        padding: .5rem 2rem 2rem 2rem;

    }
    #formulario-login label{ font-size: .8rem; color: #b2afaf; }
    #formulario-login h5{
        font-size: 1.7rem;
        font-weight: 400;
        color: #625151;
    }
    #formulario-login  button { font-weight:500;}
    /****** */
    .formulario-registro{
        /**max-width: 1000px !important;**/
        margin-top: 3rem;
        margin-bottom: 5rem;
        border: 2px solid #efefef;
        padding: 2rem 3rem 3rem 3rem;
        border-left: 5px solid #7f2535;
    }
    .datosEmpleado{ display:flex; justify-content: space-between; font-size: 0.89rem;}
    .btn-vino-o{
        border: 2px solid #7f2535;
    }
    .area_datos_empleado{
        border-top: 2px solid #efefef;
    }

    .form-registro{
        /**max-width: 1000px !important;**/
        margin-top: 3rem;
        margin-bottom: 5rem;
        border: 2px solid #efefef;
        border-radius: 5px;
        /* padding: 2rem 3rem 3rem 3rem; */
        border-left: 5px solid #7f2535;
    }
    .bg-grey{ background:#007bff; border:none !important; }
    .bg-grey:hover{ background: #0064cf !important; }

    .botonera button {
        padding-left: 3rem;
        padding-right: 3rem;
    }
    .datos{padding: 2rem 3rem}
    .paddingDatosCta{ padding: 3rem; }
    .capchaStyle{ width: 25%; }

    .text-mail{
        font-weight: 400;
        color: #868686;
        text-align: center !important;
    }

    .link-nuevo-codigo{
        cursor:pointer;
        color: #0064cf;
        text-decoration: underline;
        font-size: .89rem;
        font-weight: 400;
        margin-top: 3rem;
    }
    .link-nuevo-codigo:hover{  color:#0259b6; }

    .cod-activacion{
        color: #818181;
        font-weight: 500;
        font-size: 1.3rem;
    }
    .div-activar-cuenta{
        display: flex;
        justify-content: flex-end;
        margin-top: 3rem;
    }
    .inputActivacion{ width: 50%; }
    .activar-cuenta-boton{ width: auto;}

    .finalizarRegistro{ width: 50%; }
    .paddingFinalizar{ padding:3rem; }

    .codigoActivacion ::placeholder{
        color: #d1cfcf;
        font-weight: 400;
    }

    .padding-activacion{ padding: 3rem 3rem;}

/* ########### MEDIA QUERYS <900PX (CELULARES) ############# */
@media only screen and (max-device-width : 900px) {
    .botonera button {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .botonera .leyenda { font-size: .95rem;}
    .form-registro{
        border: 1px solid #ededed;
        border-left: 3px solid #7f2535;
    }
    .datosEmpleado{ display:flex; flex-direction: column; justify-content: space-between;}
    .paddingDatosCta{ padding: 1rem; }
    .capchaStyle{ width: 100%; }

    .text-mail{
        color: #868686;
        text-align: justify !important;
    }
    .div-activar-cuenta{
        justify-content: center;
         margin-top: 1rem;
    }
    .inputActivacion{ width: 100%; }
    .activar-cuenta-boton { width: 100%; }

    .finalizarRegistro{ width: 100%; }
    .paddingFinalizar{ padding:2rem 0; }
    .codigoActivacion ::placeholder{ font-size: .9rem; }
    .padding-activacion{ padding: 1.5rem 1rem;}
}


</style>
